<template>
  <span>
    <a v-for="(url,network) in socialNetworks" :key="network" :href="url" target="_blank">
      <span class="icon is-large has-text-primary">
        <i class="fab fa-lg" :class="[`fa-${network}`]"></i>
      </span>
    </a>
  </span>
</template>

<script>
export default {
  props: ['color'],
  data () {
    return {
      socialNetworks: {
        youtube: 'https://www.youtube.com/channel/UCKl3a1wgCPIz31kYj3wYArQ',
        twitter: 'https://twitter.com/mSchools_MWC',
        flickr: 'https://www.flickr.com/photos/mwcbarcelona/albums',
        linkedin: 'https://www.linkedin.com/company/mwcb-mschools/'
      }
    }
  }
}
</script>

<style>
</style>
